import StoreReceiptContainer from './StoreReceiptContainer';
export default StoreReceiptContainer;
